import { useState, useEffect } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";

function Progress() {
  const [sessions, setSessions] = useState([]);
  const username = localStorage.getItem("username");
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL + "/api"; // must start with REACT_APP_

  useEffect(() => {
    axios.get(`${BACKEND_URL}/sessions?username=${username}`).then(res => {
      setSessions(res.data.sessions);
    });
  }, [username]);

  const data = {
    labels: sessions.map(s => s.date),
    datasets: [
      {
        label: "Session Feedback",
        data: sessions.map(s => Math.floor(Math.random() * 10) + 1), // placeholder scores
        fill: false,
        borderColor: "blue",
      },
    ],
  };

  return (
    <div>
      <h2>Progress Dashboard</h2>
      <Line data={data} />
    </div>
  );
}

export default Progress;
